import React, { Component } from "react";
import {LOGIN_TYPE_ADMIN} from "./helper/Constants";
import $ from 'jquery';
import Apihelpers from "./helper/ApiHelper";
import Header from "./include/Header";
import UnAuthorised from "./UnAuthorised";
import { reactLocalStorage } from "reactjs-localstorage";
import moment from 'moment';


export default class AuditHistoryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      filters:{
        page:0,
        limit:5,
        totalCount:0,
        collection:'all',
        panel:'all',
      },
      listData:[]
    }
  }


  componentDidMount() {
    this.loadRecords();

    $(document).ready(function(){
      $(".auditHistoryPage").on('click','.btn-icon',function(){
        var moreVal = $(this).parents('tr').next('tr');
        if (moreVal.is(':visible')) {
          moreVal.css('display','none');
        } else {
          $(".auditHistoryPage .moreVal").css('display','none');
          moreVal.css('display','');
        }
      })
    });
  }

  loadRecords = () => {
    let parmes = '?limit='+this.state.filters.limit+'&skip='+(this.state.filters.limit * this.state.filters.page)+'&collection='+this.state.filters.collection+'&panel='+this.state.filters.panel;
    this.setState({loader: true });
    Apihelpers.getdataresponse('audithistory/auditHistoryList'+parmes).then(res => {
      console.log('res.data',res.data);
      if (res.data.status === true) {
        let data = res.data.data;
        //console.log('aaaaaaaaaaaaa',data.totalCount);
        this.setState({
          filters:{...this.state.filters, totalCount:data.totalCount},
          listData:data.record,
          loader: false
        })
      }
    });
  }

  loadPage = (e) => {
    let start = Number(e.target.getAttribute("data-i"));
    this.setState({
      filters: {...this.state.filters, page: start}
    });
    setTimeout(()=>{
      this.loadRecords();
    },100);
  }
  changeLimit = (e) => {
    let limit = Number(e.target.value);
    this.setState({
      filters: {
        page:0,
        limit:limit,
        totalCount:0,
        panel:'all',
        collection:'all'
      }
    });
    setTimeout(()=>{
      this.loadRecords();
    },100);
  }

  render() {
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {
      const renderPaging = () => {
        let pages = (this.state.filters.totalCount / this.state.filters.limit);
        //console.log('pages',pages);
        let pagingHmtl = [];
        for (var i = 0; pages > i; i++ ) {
          pagingHmtl.push(<span key={i} data-i={i} className={(this.state.filters.page == i) ? 'btn active' : 'btn'} onClick={(e)=>{this.loadPage(e)}}>{i+1}</span>);
        }
        return pagingHmtl;
      }
      return (
        <div className="wrapper">
          <Header />
          <div className="container">
            <div className="clientListPage auditHistoryPage">
              {
                //JSON.stringify(this.state.filters,null,2)
              }
              <div className="titleBg">
                <div className="row align-items-center">
                  <div className="col">
                    <h3 className="title">Audit History  <span className="count">(Showing {this.state.listData.length} out of {this.state.filters.totalCount} )</span></h3>
                  </div>
                </div>
              </div>

              <div className="filterRow">
                <div className="form-group">
                  <select className="form-control" onClick={(e)=>{this.setState({
                    filters: {...this.state.filters, collection: e.target.value}
                  })}}>
                    <option value="all">All</option>
                    <option value="bbuser">BBUser</option>
                    <option value="masterservice">Master serives</option>
                    <option value="fuel">Configuration</option>
                    <option value="common_setting">Setting</option>
                    <option value="sourcesList">Source List</option>
                  </select>
                </div>
                <div className="form-group">
                  <select className="form-control" onClick={(e)=>{this.setState({
                    filters: {...this.state.filters, panel: e.target.value}
                  })}}>
                    <option value="all">All</option>
                    <option value="clientEditPage">Client Plan Edit History</option>
                    <option value="clientProfileEdit">Client Profile Edit History</option>
                    <option value="planStatusChange">Client Plans Status History</option>
                    <option value="apiSourceOrder">API Source Order Edit History</option>
                    <option value="settingPage">Setting Page Edit History</option>
                    <option value="configuration">Configuration Edit History</option>
                    <option value="configurationRemove">Configuration Remove History</option>
                    <option value="servicePlanList">Service Plan History</option>
                    <option value="sourceList">Source List</option>
                  </select>
                </div>
                <div className="form-group btnRow">
                  <button className="blueBtn" type="button" onClick={()=>{this.loadRecords()}}><i className="fa fa-filter"></i></button>
                </div>
                <div className="form-group btnRow">
                  <button className="backBtn" type="button" onClick={()=>{
                    this.setState({
                      filters: {
                        page:0,
                        limit:5,
                        totalCount:0,
                        panel:'all',
                        collection:'all'
                      }
                    });
                    setTimeout(()=>{
                      this.loadRecords();
                    },100);
                  }}><i className="fa fa-undo"></i></button>
                </div>
              </div>

              <div className="tableBorder">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Collection Name & Object Id</th>
                      <th>User Name & IP</th>
                      <th>Panel Page</th>
                      <th>Updated On</th>
                      <th style={{width:'110px'}}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.listData.length > 0 ?
                        this.state.listData.map((item, index)=>{
                            var diff = '';
                            let value1 = item.oldValue;
                            let value2 = item.requestParams;
                            if (typeof value1 === "object" && value1 && typeof value2 === "object" && value2) {
                              for (let subKey in value1) {
                                if (value2.hasOwnProperty(subKey)) {
                                  //console.log('has own property',subKey);
                                  if(value1[subKey] !== value2[subKey]) {
                                    if (typeof value2[subKey] === 'string' || typeof value2[subKey] === 'boolean' || typeof value2[subKey] === 'number') {
                                      diff += '<br /><span style="color:#978b00">'+subKey+':'+value2[subKey]+'</span>';
                                    } else {
                                      if (Array.isArray(value2[subKey]) && value2[subKey].length > 0) {
                                        if(typeof value2[subKey][0] === 'string') {
                                          let str = JSON.stringify(value2[subKey]);
                                          if (str !== JSON.stringify(value1[subKey])) {
                                            diff += '<br /><span style="color:#978b00">'+subKey+':'+str+'</span>';
                                          }
                                        }
                                      }
                                      //diff += '<br />'+subKey+':'+value2[subKey];
                                    }
                                  } else {
                                    //diff += '<br />'+subKey+':'+value2[subKey];
                                  }
                                } else {
                                    diff += '<br /><span style="color:red">'+subKey+':'+value2[subKey]+'</span>';
                                }
                              }
                            }
                            //console.log('diff',diff);

                            let objides = '';
                            if(item.update_id.length > 0) {
                              item.update_id.forEach((it)=>{
                                objides += it+'<br />';
                              })
                            }
                            
                          return(
                            <React.Fragment key={item._id}>
                              <tr>
                                <td>{item.collectionName}<br /><div dangerouslySetInnerHTML={{ __html:objides }} /></td>
                                <td>{item.bbuserObj[0].name} <br /> {item.userIPAdress}</td>
                                <td>{item.panelPage}</td>
                                <td>
                                  {(item.createdAt) ? moment(item.createdAt).format('lll') : '--'}
                                </td>
                                <td>
                                  <button className="btn-icon"><i className="fa fa-arrow-down"></i></button>
                                </td>
                              </tr>
                              <tr className="moreVal" style={{'display':'none'}}>
                                <td colSpan="5">
                                  <div className="jsonViewRow">
                                    <div className="row">
                                      <div className="col-md-6">
                                        <h4 className="title">Old Value In JSON</h4>
                                        <pre>
                                          {JSON.stringify(item.oldValue,null,2)}
                                        </pre>
                                      </div>
                                      <div className="col-md-6">
                                        <h4 className="title">New Value In JSON</h4>
                                        <pre>
                                          {JSON.stringify(item.requestParams,null,2)}
                                        </pre>
                                      </div>
                                    </div>
                                    
                                    {
                                      diff !== '' ? (
                                          <div style={{'display':'none'}}>
                                            <h4 className="title">Different hints</h4>
                                            <div dangerouslySetInnerHTML={{ __html:'{'+diff+'<br />}' }} />
                                          </div>
                                        ) : ''
                                    }
                                  </div>
                                </td>
                              </tr>
                            </React.Fragment>
                          )
                        })
                      :
                      <tr>
                        <td colSpan="5">Record Not Found...</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              <div className="row">
                <div className="col">
                  <div className="pageing">
                    {/* <span className="btn active">1</span>
                    <span className="btn">2</span>
                    <span className="btn">3</span>
                    <span className="btn">4</span> */}
                    {renderPaging()}
                  </div>
                </div>
                <div className="col-auto">
                  <select className="form-control" onChange={this.changeLimit} defaultValue={this.state.filters.limit}>
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="40">40</option>
                    <option value="50">50</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          
          <div className="loader" style={{ display: `${this.state.loader ? 'block' : 'none'}`, zIndex:'111'}}>
            <div className="bg" />
            <img className="loadingImg" src="/assets/images/loading.gif"  alt="" />
          </div>
        </div>
      )
    } else {
      return (
        <UnAuthorised></UnAuthorised>
      )
    }
  }

}